import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

type AlignmentType = 'start' | 'end';

@Component({
  selector: 'sn-player-footer-section, [snPlayerFooterSection]',
  templateUrl: './player-footer-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__footer-section',
    '[style.justifyContent]': 'flexAlignment',
  },
})
export class SnPlayerFooterSectionComponent {
  @Input()
  set alignment(value: AlignmentType) {
    this.flexAlignment = `flex-${value}`;
  }

  public flexAlignment = 'flex-start';

  constructor() {}
}
